export const getStorageUrl = (childPath: string): string => {
  return `https://storage.googleapis.com/renderro-mvp.appspot.com/${childPath}`
}
